import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import useModalDialog from './useModalDialog';

const SaveCaseConfirmationDialog = ({ isEditMode, isSaving, onConfirm, onCancel }) => {
  const cancelRef = useRef(null);
  const dialogRef = useModalDialog(cancelRef);

  return createPortal(
    <dialog
      ref={dialogRef}
      className="case-address-dialog"
      aria-labelledby="case-save-confirmation-title"
      aria-describedby="case-save-confirmation-description"
      aria-busy={isSaving}
      onCancel={(event) => {
        event.preventDefault();
        if (!isSaving) onCancel();
      }}
    >
      <div className="p-4">
        <h2 id="case-save-confirmation-title" className="h5 mb-3">
          {isEditMode ? '¿Quieres guardar los cambios del caso?' : '¿Quieres guardar el caso?'}
        </h2>
        <p id="case-save-confirmation-description" className="mb-0 text-muted">
          Confirma el guardado o vuelve al formulario para seguir completando los datos.
        </p>
      </div>
      <div className="d-flex flex-wrap justify-content-end gap-2 p-4 pt-0">
        <button ref={cancelRef} type="button" className="btn btn-outline-brand" onClick={onCancel} disabled={isSaving}>
          Seguir editando
        </button>
        <button type="button" className="btn btn-brand" onClick={onConfirm} disabled={isSaving}>
          {isSaving ? 'Guardando…' : 'Sí, guardar'}
        </button>
      </div>
    </dialog>,
    document.body
  );
};

export default SaveCaseConfirmationDialog;
